import { z } from 'zod';
import { IdSchema, ProductChangeTypeSchema, paginated } from './common.schema';

// Backend entity: ProductVersion
// Source: /packages/db/prisma/schema.prisma -> model ProductVersion
// TODO: confirmar shape exacto de "snapshot" cuando se conozca el formato real.

export const ProductVersionSchema = z.object({
  id: IdSchema,
  // El back manda `productId` NUMÉRICO (es el id de la fila por fuente, no el
  // SKU). Con `z.string()` la respuesta entera fallaba el parse y la pestaña
  // mostraba un ZodError crudo. `IdSchema` normaliza número a string, igual
  // que el resto de los ids del proyecto.
  productId: IdSchema,
  version: z.number().int().positive(),
  snapshot: z.unknown(),
  changeType: ProductChangeTypeSchema,
  changedBy: z.string().nullable().optional(),
  changeReason: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
});
export type ProductVersion = z.infer<typeof ProductVersionSchema>;

export const ProductVersionListSchema = paginated(ProductVersionSchema);
export type ProductVersionList = z.infer<typeof ProductVersionListSchema>;

// `GET /products/{sku}/versions/counts` (backend, revision hub-service-00228).
// Una fila por fuente QUE TIENE row del producto, incluidas las que todavía no
// escribieron ninguna versión (`versions: 0`), ordenadas por cantidad. 404 si
// el SKU no existe en ninguna fuente.
//
// Reemplaza el rodeo anterior del selector de fuentes: un pedido por fuente con
// `limit=1` solo para leer el total del envelope.
export const ProductVersionCountSchema = z.object({
  sourceSlug: z.string(),
  productId: IdSchema,
  versions: z.number().int().nonnegative(),
  lastChangeAt: z.coerce.date().nullable().optional(),
});
export type ProductVersionCount = z.infer<typeof ProductVersionCountSchema>;

export const ProductVersionCountsSchema = z.array(ProductVersionCountSchema);
